import { useEffect } from "react";

export function useDocumentTitle(title: string) {
  useEffect(() => {
    const base = "Cipher & Row";
    document.title = title ? `${title} | ${base}` : `${base} · Trust Infrastructure for Freight`;
    return () => {
      document.title = `${base} · Trust Infrastructure for Freight`;
    };
  }, [title]);
}
